import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
  selector: 'app-add-child-renderer',
  templateUrl: './add-child-renderer.component.html',
  styleUrls: ['./add-child-renderer.component.scss']
})
export class AddChildRendererComponent implements ICellRendererAngularComp {
  params: any;
  label = 'Add Child';

  agInit(params: any): void {
    this.params = params;
    this.label = params.addChildRowLabel || 'Add Child';
  }

  refresh(): boolean {
    return true;
  }

  onClick(): void {
    // Call the callback passed from the grid
    this.params.onAddChild(this.params.data);
  }
}
